import { switchMap } from './switchMap';
export function switchMapTo(innerObservable) {
    return switchMap(function () { return innerObservable; });
}
//# sourceMappingURL=switchMapTo.js.map